module.exports = __webpack_public_path__ + "static/media/6COPUOS2.18126e10.jpg";